module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cols2",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "three",
    attrs: {
      "id": "timeline"
    }
  }, [_c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1870\n\t\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1884\n\t\t\t\t")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t19 March 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t22 March 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tMay 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t28 December 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1896 and beyond\n\t\t\t\t")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1902\n\t\t\t\t")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1903\n\t\t\t\t")]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1935\n\t\t\t\t")]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Family settles in Lyon."), _c('br'), _vm._v("\n\t\t\t\t\tThe Lumière Brothers are 6 and 8 years old.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Company markets the \"Blue Label\" photographic plates, invented by Louis Lumière in 1881."), _c('br'), _vm._v("The Lumière photography factory goes on to become N° 1 in Europe within ten years.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("In Lyon, Louis Lumière shoots the film Sortie d’usine at the Chemin Saint-Victor."), _c('br'), _vm._v("This is the first turning of the Cinematograph hand-crank. In 1929, the Chemin Saint-Victor is re-christened Rue du Premier-Film.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("In Paris, the members of the Société d’Encouragement pour l’Industrie Nationale receive the visit from Louis Lumière who comes to present his Cinematograph."), _c('br'), _vm._v("The screening of "), _c('i', [_vm._v("Sortie d’Usine")]), _vm._v(" is a scientific triumph.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière shoots new films in Lyon, including "), _c('i', [_vm._v("Le Jardinier")]), _vm._v(" and "), _c('i', [_vm._v("Le Petit Espiègle")]), _vm._v(" that later becomes the famous "), _c('i', [_vm._v("Arroseur et arrosé")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Return to Paris - Thirty three curious spectators come to the Grand Café on Boulevard des Capucines (today the Hôtel Scribe), right in the middle of the Christmas holidays, to see the first fee-paying public screening of the Cinematograph."), _c('br'), _vm._v("They each pay 1 French franc. During the following weeks, over 2000 Parisians queue up each day to see the projections.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Company and its operators screen and shoot films in the UK, Italy, Spain, Germany, Egypt, Algeria, Tokyo, Moscow, New York, Mexico, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière opens a Photorama room in Paris able to accommodate several hundreds of spectators for projections of 360° photographs on a giant circular screen.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière develops the Autochrome, the first commercial process for colored photographs on glass plates, made available to all in 1907.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière develops his 3D cinematography process: the films are watched using anaglyph glasses.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "two"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(3deg)"
    },
    attrs: {
      "src": require("../assets/media/bord_de_mer.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-2deg)"
    },
    attrs: {
      "src": require("../assets/media/brochure_lumiere2.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(1deg)"
    },
    attrs: {
      "src": require("../assets/media/grand_prix.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-3deg)"
    },
    attrs: {
      "src": require("../assets/media/salon.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(2deg)"
    },
    attrs: {
      "src": require("../assets/media/planche.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518fb0b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/timeline.vue
// module id = 46
// module chunks = 0